import React, { Component } from 'react';
import PopUp from '../../../../commonModules/interface/PopUp';
import { LineStats } from './Stats/LineStats';

class ProductStats extends Component {
    state = {  }
    render() {
        const {product} = this.props;
        return (
            <PopUp
                title={`Analyses Entrées Sorties ${product.name}`}
                close={this.props.close}
                appbar
            >
                {/* Add Filters */}
                {/* Add select Year || Date range */}
                <LineStats
                    {...this.props}
                />
            </PopUp>
        );
    }
}

export default ProductStats;